<template>
  <div class="progress-wapper">
    <div class="progress-loading">
      <div class="play-slider">
        <div class="actual-text" v-if="checkValue == 'actual'">模拟时间：{{ actualTime }}</div>
        <div :class="checkValue == 'plan'? 'actual-time': 'actual-time-actual'">
          <el-slider
            v-model="timeSlidervalue"
            :format-tooltip="timestepToolTip"
            @change="sliderChange"
            :min="0"
            :max="modelPlayConfig.max"
            :marks="marks"
          ></el-slider>
          <el-slider
            v-show="checkValue == 'plan'"
            class="one-slider"
            v-model="timeSlidervalue"
            :show-tooltip="false"
            :min="0"
            :max="modelPlayConfig.max"
            @change="sliderChange"
            :marks="guideMarks"
          ></el-slider>
        </div>
        
      </div> 
      <div class="progress-btn" @click="beginOrEndFun">
        <p class="s-e-btn" :class="beginEnd? 'pause' : 'start'"></p>
      </div>
      <div class="progress-end loading-end" v-if="playEnd"
      @click="loadingEnd">退出模拟</div>
      <div class="progress-end-check" v-else>
        <el-select v-model="checkValue" 
          :popper-append-to-body="false"
          @change="selectChangePlan"
          placeholder="请选择">
          <el-option
            v-for="item in checkOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div>
    <div v-if="progressModelShow" 
      element-loading-text="模型加载中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.2)"
      v-loading="modelLoading" 
      ref="progressLoadingIframe" 
      id="progressModel" 
      class="progress-model"
      ></div>
    <!-- <iframe
      ref="progressLoadingIframe"
      frameborder="0"
      width="100%"
      height="100%"
      @load="imageProgressLoad"
      :src="progressImageBIMSrc"
    ></iframe> -->
    <div class="progress-content" v-if="modelPlayConfig.messageShow && checkValue == 'plan'">
      <p class="slider-time" v-if="modelPlayConfig.messageShow">当前日期：{{playNowDate}}</p> 

      <p v-for="(msg,index) in modelPlayConfig.message" :key="index">{{msg}}</p>
    </div>
    <div class="progress-content progress-actual" v-if="checkValue == 'actual' && listSetColor.length > 0">
      <div v-for="(item,index) in listSetColor" :key="index" class="actual-list">
          <p>工程结构：{{item.Progress_Name}}</p>
          <p>计划时间： {{item.Progress_planstarttime}}--{{item.Progress_plannendtime}}</p>
          <p>填报时间： {{item.Progress_unittime }}</p>
          <p>计划完成比例： {{item.Progress_planratio}}%</p>
          <p>实际完成比例： {{item.Progress_actualratio}}%</p>
          <p>状态：{{item.Progress_state}}</p>
          <p>填报人： {{item.Progress_createuser}}</p>
          <el-divider v-if="index<listSetColor.length-1"></el-divider>
      </div> 
    </div>


    <div class="progress-list-tab tab-milestone" v-show="checkValue == 'plan'">
      <p>里程碑节点</p>
      <ul>
        <li v-for="(item,index) in $project.projectData.milestone" :key="index" class="tab-list font-FFFFFF-50 font-5-family"  v-html="item"> 
        </li>
      </ul>
    </div>
    
    <div class="progress-list-tab model-legend">
      <p>进度图例</p>
      <ul v-if="setLegend && checkValue == 'plan'">
        <li class="tab-list font-FFFFFF-50 font-5-family">
          <span class="model-legend-icon"></span>待进行
        </li>
         <li class="tab-list font-FFFFFF-50 font-5-family">
          <span class="model-legend-icon bgfa8c16"></span>进行中
        </li>
         <li class="tab-list font-FFFFFF-50 font-5-family">
          <span class="model-legend-icon bg096dd9"></span>已完成
        </li>
      </ul>
      <ul v-else>
        <li class="tab-list font-FFFFFF-50 font-5-family">
          <span class="model-legend-icon cd4380d"></span>1%-25%
        </li>
        <li class="tab-list font-FFFFFF-50 font-5-family">
          <span class="model-legend-icon cfa8c16"></span>26%-50%
        </li>
        <li class="tab-list font-FFFFFF-50 font-5-family">
          <span class="model-legend-icon cffe240"></span>51%-75%
        </li>
        <li class="tab-list font-FFFFFF-50 font-5-family">
          <span class="model-legend-icon c0bc286"></span>76%-99%
        </li>
        <li class="tab-list font-FFFFFF-50 font-5-family">
          <span class="model-legend-icon c096dd9"></span>100% 已完成
        </li>
      </ul>
    </div>

        
  </div>
</template>
<script>
export default {
  name: "progressLoading",
  data() {
    return {
      progressModelShow: true,
			// 关于模型
			progressLoadingIframe: null,
      
      // projectID都一样，planid 和 modelid 有变化
      planid: '',
      modelid: '',
      modelPlayConfig: {
        message: [],
				messageShow: false,
				max:100, 
				startDate: null,
				endDate: null,
				resData: null,
				currentDate: null,
				taskArr: null,
			},
			progressImageBIMSrc: "",
			shouldhighlight: [],  // 模拟 正在进行的构件  要取消隔离，取消着色
			finishResetModelColor: [], // 模拟完成的构件  要取消隔离，取消着色

      // 关于播放
      iframeLoadingOK: false,  // 模型加载完毕为true
      playNowDate: "",
      timeAutoData: 400, // 播放时间初始化为1000ms
      beginEnd: false,  // 判断播放还是暂停，true为播放，false为暂停
      timeSlidervalue: 0,
      nowInitValue: 0,
      dateStep: 7, // 播放时 时间间隔是几天

      // marks: {},
      // movingMarks: {},
      modelLoading:true,
      allNowingsetColor: [],//记录点击当前进度时候所有着色的构件，在点击继续模拟时候resetcolor
      setLegend: false, // setLegend为false展示百分比着色图例，为true展示完成未完成着色
      playEnd: false, // 记录状态是开始播放还是暂停
      checkOptions: [
        {
          value: 'plan',
          label: '按计划模拟',
        },
        {
          value: 'actual',
          label: '按实际模拟',
        }
      ],
      checkValue: 'plan',
      // getPlayingData: null,
      getPlayingData:{
        List : [],
        end: '',
        start: '',
      },
      listSetColor: [],
      actualTime: '',// 实际模拟时候时间
      playingActualModelElement: [], // 记录实际模拟时候着色的构件
      
    };
  },
  filters: {
      flt_datetimefromserver(str) {
          let str1 = str;
          if (str) {
              str1 = str.replace("T", " ");
          }
          return str1;
      }
  },
  computed: {
    guideMarks() {
      let marks = {};
      let tag = {
        'class': {
          foo: true,
          bar: false
        }
      };
      for (let i = 0; i <= this.modelPlayConfig.max; i++) {
        for(let m in this.movingMarks){
          if(i == m){
            marks[i] = {
              
              class: 'addlll',
              label: this.$createElement("span", tag, this.movingMarks[m]),
            }
          }
        }
      }
      return marks;
    },
    marks() {
      let datelist = this.getDateSplit(this.$project.projectData.startDate, this.$project.projectData.endDate)
      let gap = Math.floor(this.modelPlayConfig.max / (datelist.length + 1))
      let result = {}
      for(let i=0; i<datelist.length; i++) {
        let value = i * gap + 16;
        result[value] = datelist[i]
      }
      return result;
    },
    movingMarks() {
      let mMarks = {}
      let pos = Object.keys(this.marks)
      pos = pos.map( item => parseInt(item))
      let gap = pos[1] - pos[0];
      for(let i=0; i<pos.length; i++) {
        for(let a of this.$project.projectData.milestoneMarks) {
          let temp = a.split(' ');
          if(temp[0].indexOf(this.marks[pos[i]]) > -1) {
            let day = temp[0].split('.')[2]
            let number = Math.floor(gap / 32 * day) + pos[i]
            mMarks[number] = temp[1]
          }
        }
      }
      return mMarks;
    }
  },
  watch: {
    // 当变量 shouldhighlight 变化时，会针对 shouldhighlight 进行高亮
    // ------------------------------------------------------------
    'shouldhighlight': {
      handler(val) {
        let playModelView = this.progressLoadingIframe;
        if(val.length == 0) return
        this.func_setElementColor(playModelView, val, 250, 140, 22, 1);
      },
      deep: true
    },
    'finishResetModelColor': {
      handler(val) {
        let playModelView = this.progressLoadingIframe;
        if(val.length == 0) return
        this.func_setElementColor(playModelView, val, 9, 109, 217, 1);
      },
      deep: true
    }
  },
  created(){
    // this.marks = window.pubilc_config.proMarks;
    // this.movingMarks = window.pubilc_config.proMovingMarks;
    this.planid = this.$project.projectData.platform.progressLoadingPlanId;
  },
  mounted() {
    this.getElementByModle(); 
  },
  methods: {
    modelloadingfun(modelId){ 
      let _projectId = this.$project.projectData.platform.progressLoadingProjectId;
      let model = null 
      let obj = {
          modelID: modelId,//模型id
          projectID: _projectId,//项目id
          versionNO: '',//版本 ""为最新版本
          viewID: '',//指定视图id，""为默认视图  model-more
          DOM: document.querySelector('.progress-model')//渲染容器（请提前确定容器含有宽高）
      }
      model = window.model = new window.bim365.BIMModel(obj)
      // 因为数字总图走的是GIS相关，在此设置entryFromGIS = false
      model.resource.entryFromGIS = false
      model.load()
      //model.load 之后实例化BIM365API 请在load后获取BIM365API
      this.progressLoadingIframe = window
      model.BIM365API.Events.finishRender.on('default',()=>{//监听模型加载完成事件
          console.log('模型加载完成','======')
          this.progressLoadingIframe.model.BIM365API.Controller.isolateElementByElementId();
          
          this.modelLoading = false;  // 加载的loading改为false
          document.getElementById('viewCube').innerHTML = '';
          document.getElementById('viewCube').style.width = '0px';
          document.getElementById('viewCube').style.height = '0px';
          this.iframeLoadingOK = true;  // 模型加载完毕
          this.getInitLoading();

      })
    },

    // 请求接口获取模型相关数据
    getElementByModle() {
      let _this = this;
      _this
        .$axios({
          url: `${window.pubilc_config.webserverurl}/api/Plus/PlusTask/GetMaterialEleInfoByPlanId`,
          method: "post",
          data: _this.$qs.stringify({
            PlanId: _this.planid
          })
        })
        .then(x => {
          if (x.data.Ret > 0) {
            // console.log(x.data.Data)
            // _this.modelPlayConfig.startDate = new Date(x.data.Data.start);
            // _this.modelPlayConfig.endDate = new Date(x.data.Data.end);
            _this.modelPlayConfig.startDate = new Date(_this.$project.projectData.startDate);

            // 由于计划工期结束时间为2023-03-20，平台数据绑定不是，现在强制转换为2023-03-20
            // _this.modelPlayConfig.endDate = new Date('2023-03-20');
            _this.modelPlayConfig.endDate = new Date(_this.$project.projectData.endDate);

            _this.modelPlayConfig.resData = x.data.Data;
            _this.modelPlayConfig.max = _this.$formatData.DateDiff(
              _this.modelPlayConfig.startDate,
              _this.modelPlayConfig.endDate
            );

            this.nowInitValue = _this.$formatData.DateDiff(
              _this.modelPlayConfig.startDate,
              new Date(),
            ); 
            let _modelId = x.data.Data.ModelIds;  // 所有的构件id，加载模型
            
            _this.$axios({
                url: `${window.pubilc_config.webserverurl}/api/Schedual/Schedual/GetProgressByPlanId`,
                method: 'post',
                data: _this.$qs.stringify({
                  PlanId: _this.planid
                })
            }).then(x => {
                if(x.data.Ret == 1){
                  _this.getPlayingData = x.data.Data;
                  _this.modelloadingfun(_modelId);
                }
            }).catch(x => {
              console.log(x)
            })
          } else {
            _this.$message.error(x.data.Msg);
          }
        }).catch(err=>{
            console.log(err)
        });
    },
    // 点击播放
    beginOrEndFun() {
      let _this = this;
      if (!_this.iframeLoadingOK) {
        _this.$message.error("模型加载中...");
        return false;
      }
      // this.beginEnd为true，开始播放，this.beginEnd为false为结束播放
      _this.beginEnd = !_this.beginEnd;
       _this.playEnd = true;
      _this.setLegend = true;
      if (_this.beginEnd) {
				// 开始播放
				this.modelPlayConfig.messageShow = true;

        if (_this.timeSlidervalue > _this.modelPlayConfig.max) {
          _this.timeSlidervalue = 0;
          _this.sliderChange(0);
          _this.timestepToolTip(0);
        }
        if(_this.allNowingsetColor.length > 0){
          _this.resetallNowingsetColor();
        }
        _this.playLoadingFun(); 
      } else {
        // 暂停播放，记录当前播放的时间  点击可以继续播放
        clearInterval(_this.playTimeHandler);
        _this.beginEnd = false;
      }
    },
    // 删除构件初始化的颜色
    resetallNowingsetColor(){
      let _this = this;
      // 清空初始化被着色的构件
      let _arr = _this.allNowingsetColor.flat();

      // flat()扁平化  [...new Set(_arr)]去重，
      _arr = [...new Set(_arr)];

      _this.progressLoadingIframe.model.BIM365API.Controller.resetElementColor(_arr);
      setTimeout(()=>{
        _this.allNowingsetColor = [];
      },500)
        
        // _this.progressLoadingIframe.model.BIM365API.Controller. isolateElementByElementId();
      
    },
    // 点击停止播放
    loadingEnd(){
      let _this = this;
      _this.removeIsolateElement();
      _this.beginEnd = false;
      _this.playEnd = false;
      _this.setLegend = false;
      clearInterval(_this.playTimeHandler);
      if(_this.checkValue == 'plan'){
        // 点击停止需要初始化===imnitTodaySetColor为恢复到当前时间根据实际完成百分比的数据
        _this.initTodaySetColor();
        // 暂停模拟，清除定时器,展示正在模拟的message置空
        _this.modelPlayConfig.message = [];
      }else{
        _this.listSetColor = [];
        _this.sliderChange(0);
        
      }
      
    },
    // slider鼠标滑过tooltip
    timestepToolTip(val) { 
      let date = null
      this.checkValue == 'plan' ? date = new Date(this.modelPlayConfig.startDate) : date = new Date(this.dateMin)
      date.setDate(date.getDate() + val)
      let datestrTool = this.$formatData.dateInit(date);
      return datestrTool;
    },
    // slider值的变化
    sliderChange(value,str) {
      let _this = this;
      // 参数str就是为了x判断是不是初始化，停止播放和页面刚加载会调用
      if(str && str == 'init'){
        _this.initTodaySetColor();
        _this.setLegend = false;
      }else{
        if(_this.allNowingsetColor.length > 0){
          _this.resetallNowingsetColor();
        }
        _this.removeIsolateElement();
        _this.progressLoadingIframe.model.BIM365API.Controller.isolateElementByElementId()
        
        if(_this.checkValue == 'plan'){
          if (value > _this.modelPlayConfig.max) {
            _this.playEnd = false;
            return;
          }
          _this.drawChange(value);
          _this.setLegend = true;
        }else{
          if (value > _this.modelPlayConfig.max) {
            _this.playEnd = false;
            _this.listSetColor = [];
            return;
          }
          
          _this.getListTimePoint(value);
          _this.setLegend = false;
        }
      }
    },

    // 播放每秒前进一步
    playLoadingFun() {
      let _this = this;
      let timeauto = _this.timeAutoData;
      
      if (_this.timeSlidervalue > _this.modelPlayConfig.max) {
        _this.timeSlidervalue = 0;
        _this.beginEnd = false;
        _this.playEnd = false;
        _this.sliderChange(0);
        _this.timestepToolTip(0);
        return;
      }

      if(_this.checkValue == 'plan'){
        _this.playTimeHandler = setTimeout(() => {
          _this.timeSlidervalue += _this.dateStep;
          _this.drawChange(_this.timeSlidervalue);
          _this.playLoadingFun();
        }, timeauto);
      }else{
        _this.setLegend = false;
        _this.playTimeHandler = setTimeout(() => {
          _this.timeSlidervalue += _this.dateStep;

          _this.getListTimePoint(_this.timeSlidervalue);
          _this.playLoadingFun();
        }, timeauto);
      }
    },

    // 模型加载完毕  // 暂时没用到，注释掉 
    /*
    imageProgressLoad() { 
      let _this = this;
      _this.progressLoadingIframe = _this.$refs.progressLoadingIframe;
      _this.progressLoadingIframe.model.BIM365API.Events.finishRender.on("default", () => {
        _this.iframeLoadingOK = true;
        _this.getInitLoading();
      });
    },
    */
    // 初始化进度   为当前日期
    getInitLoading(){
      // ====初始化为当前时间，着色为所有进度的百分比
      let _this = this;
      _this.sliderChange(_this.nowInitValue,'init');
      _this.modelPlayConfig.messageShow = true;
    },
    // 进度模拟==每一帧都会走这里
    drawChange(inputVal){
      let _this = this;
      _this.timeSlidervalue = inputVal;
      _this.modelPlayConfig.currentDate = new Date(
        _this.modelPlayConfig.startDate
      );

      _this.modelPlayConfig.currentDate.setDate(
        _this.modelPlayConfig.startDate.getDate() + inputVal
      );

      _this.playNowDate = _this.getDateStr(_this.modelPlayConfig.currentDate);

      _this.modelPlayConfig.message = [];
      _this.modelPlayConfig.taskArr = [];
      let _arrList = [];  // 下面循环中记录了elements
      let foringPushArr = [];  // 用来储存当前循环中所有进行中的高亮的构件,
      let noArr = [];    // 当前不在时间范围的构件

      _this.modelPlayConfig.resData.List.forEach((list)=>{
        _arrList = list.Elements;
				let currentenddate = new Date(_this.modelPlayConfig.currentDate);
        if(_arrList.length > 0){
          let listElements = JSON.parse(_arrList[0].bme_elementids);
          let arr = _this.getElement(listElements);
          if(_this.$formatData.checkTime(_this.modelPlayConfig.currentDate,currentenddate,list.task_Start,list.task_FINISH)){
            foringPushArr.push.apply(foringPushArr,arr);   // foringPushArr为所有正在进行的数组，arr是当前循环中所有的构件，两个数组合并，得到当前着色的构件
            _this.shouldhighlight = foringPushArr;
            _this.modelPlayConfig.message.push(list.task_Name);
            _this.modelPlayConfig.taskArr.push(list.TaskId);
            
            _this.modelPlayConfig.message = Array.from(new Set(_this.modelPlayConfig.message)); 
          }
          else{
              let dateDiff = _this.DateDiff(_this.modelPlayConfig.currentDate,list.task_FINISH);
              // 不在时间范围内 并且在当前播放时间之前的是已经完成的构件，给它着色为已完成的颜色（目前是红色）
              if(dateDiff >= 0){
                  noArr.push.apply(noArr,arr);
                  // noArr = noArr.some(item=> _this.shouldhighlight.indexOf(item) == -1);
                  // console.log(noArr.length)
                  _this.finishResetModelColor = noArr;
              }
          } 
        }
      })
    },
    getListTimePoint(inputVal){
        let _this = this; 
        _this.timeSlidervalue = inputVal;
        let _n = new Date(_this.getPlayingData.start)
        let currentDate = new Date(_n);
        currentDate.setDate(_n.getDate() + inputVal);
        _this.listSetColor = [];
        let changeTime = _this.getDateStr(currentDate);
        _this.actualTime = changeTime;

        let _arrList = [];  // 下面循环中记录了elements
        let foringPushArr = [];  // 用来储存当前循环中所有进行中的高亮的构件,
        
        let newArr = [];  // 当前所有的list，为了处理数据方便定义的变量
        _this.getPlayingData.List.forEach((list)=>{
            _arrList = list.Elements;
            if(_arrList.length > 0){
                let listElements = JSON.parse(_arrList[0].bme_elementids);
                let arr = _this.getElement(listElements); 
                // if(当前模拟时间 <= 填报时间) push到一个数组里面，处理该数组,得到每条数据最新的数据templateList
                if(new Date(changeTime).getTime() >= new Date(list.Progress_unittime).getTime()){
                    
                    list.colorArr = arr;   // 为了着色方便，colorArr存放的是着色的构件
                    foringPushArr.push.apply(foringPushArr,arr);  //  为了删除着色方便，foringPushArr是要删除的着色构件
                    _this.playingActualModelElement = foringPushArr;
                    
                    newArr.push(list);
                    const hash = {};
                    let templateList = newArr.reduce((item, next) => {
                        if (!hash[next.Progress_treeID]) hash[next.Progress_treeID] = true && item.push(next);
                        return item;
                    }, []);
                    // templateList为newArr处理之后的数组，newArr存放的当前所有的任务，去重取其中一条，因为this.getPlayingData.List有时间排序，去重后得到的是该条进度最后一条数据
                    _this.listSetColor = templateList;
                    _this.setColorBIMFormArr(templateList)
                }
            }
        }) 

    },
    
		
		// 将 date 转为字符串
    // -----------------
    getDateStr(dt) {
      let year = dt.getFullYear();
      let month = dt.getMonth() + 1;
      let dat = dt.getDate();
      month = month.toString().padStart(2, "0");
      dat = dat.toString().padStart(2, "0");
      let finalStr = `${year}-${month}-${dat}`;
      return finalStr;
    },
    getElement(listElements) {
      let arr = [];
      listElements.forEach(item => {
        item.elementids.forEach(ids => {
          arr.push(`${item.modelid}^${ids}`);
        });
      });
      return arr;
    },
		func_setElementColor(thewin,eles, r, g, b, a) {
			this.progressLoadingIframe.model.BIM365API.Controller.setElementColor(eles, r, g, b, a,false,false);
		},
		// 两个时间差
		DateDiff(sDate1, sDate2) {
				let oDate1, oDate2, iDays;
				oDate1 = new Date(sDate1).getTime();
				oDate2 = new Date(sDate2).getTime();
				iDays = parseInt((oDate1 - oDate2) / 1000 / 60 / 60 / 24) //把相差的毫秒数转换为天数   
				return  iDays;
		},

    // 删除模型着色
		removeIsolateElement(){
      let _this = this;
      let _allReset = _this.shouldhighlight.concat(_this.finishResetModelColor)
      _allReset =  [...new Set(_allReset)]
      if(_allReset.length > 0){
        _this.progressLoadingIframe.model.BIM365API.Controller.resetElementColor(_allReset);
        // 这俩记录的是正在模拟时已完成和正在进行的构件，resetColor后要清空，要不然二次resetElementColor构件就没有隔离状态
        _this.shouldhighlight = [];
        _this.finishResetModelColor = [];
      }
      if(_this.checkValue == 'actual'){
        let _actualReset = _this.playingActualModelElement;
        _actualReset =  [...new Set(_actualReset)]
        if(_actualReset.length > 0) {
          _this.progressLoadingIframe.model.BIM365API.Controller.resetElementColor(_actualReset);
          _this.playingActualModelElement = [];
        }
      }

		},

    doHandleZero(zero) {
      let date = zero;
      if (zero.toString().length == 1) {
          date = "0" + zero;
      }
      return date;
    },
    // 获取每个月一号
    getDate() {
      let myDate = new Date();
      let tYear = myDate.getFullYear()
      let tMonth = myDate.getMonth()
      tMonth = this.doHandleZero(tMonth + 1)
      return tYear + "-" + tMonth + "-01"
    },

    // 需求为初始化页面展示为当前日期，所有的构件着色根据完成百分比进行着色
    initTodaySetColor(){
      let _this = this;
      _this.allNowingsetColor = [];
      _this.timeSlidervalue = _this.nowInitValue;
      _this.playNowDate = _this.getDateStr(new Date());
      // 循环所有构件，给有完成百分比的任务所关联的构件着色
      _this.modelPlayConfig.resData.List.forEach((list)=>{
        
          if(list.Elements.length > 0){
              let listElements = JSON.parse(list.Elements[0].bme_elementids);
              let arr = _this.getElement(listElements);
                // 记录所有的着色构件，在点击继续模拟时候要resetcolor
              if(list.Task.PERCENTCOMPLETE_ > 0 && list.Task.PERCENTCOMPLETE_ < 100){
                  // 正在进行时
                  let setcolr = _this.setRGBAElement(list.Task.PERCENTCOMPLETE_);
                  _this.allNowingsetColor.push(arr);
                  _this.progressLoadingIframe.model.BIM365API.Controller.setElementColor(arr,setcolr[0],setcolr[1],setcolr[2],setcolr[3],false,false)
              }else if(list.Task.PERCENTCOMPLETE_ == 100){
                  // 已完成
                  _this.allNowingsetColor.push(arr);
                  _this.progressLoadingIframe.model.BIM365API.Controller.setElementColor(arr,9,109,217, 0.5,false,false)
              }
          }
      })
    },
    setColorBIMFormArr(list) {
        let _this = this;
        
        // 着色是根据不同的完成百分比，来确定当前构件的颜色，将构件循环着色
        list.forEach(ele => {
            if(ele.colorArr.length > 0){
                let r,g,b,a; 
                let num = ele.Progress_actualratio * 1
                if(num > 0 && num<=25){
                    r = 212;
                    g=56;
                    b=13;
                    a=1;
                }else if(num>25  && num<=50){
                    r = 250;
                    g = 140;
                    b = 22,
                    a = 1
                }else if(num>50  && num<=75){
                    r = 255;
                    g = 226;
                    b = 64,
                    a = 1
                }else if(num>75 && num < 100){
                    r = 11;
                    g = 194;
                    b = 134,
                    a = 1
                }else{
                    r = 9;
                    g = 109;
                    b = 217,
                    a = 1
                } 
                _this.progressLoadingIframe.model.BIM365API.Controller.setElementColor(ele.colorArr, r, g, b, a,false,false);
            }
        })
        
    },
    // setRGBAElement根据百分比展示不同颜色
    setRGBAElement(num){
        let r,g,b,a;
        if(num > 0  && num<=25){
            r = 212;
            g = 56;
            b = 13;
            a = 1
        }else if(num > 25  && num <= 50){
            r = 250;
            g = 140;
            b = 22;
            a = 1
        }else if(num > 50  && num <= 75){
            r = 255;
            g = 226;
            b = 64;
            a = 1
        }else if(num > 75  && num < 100){
            r = 11;
            g = 194;
            b = 134;
            a = 1
        }else{
            r = 9;
            g = 109;
            b = 217;
            a = 1
        }
        return [r,g,b,a]
    },
    selectChangePlan(ev){
      let _this = this;
      if(ev == 'plan'){
        _this.marks = window.pubilc_config.proMarks;
        _this.modelPlayConfig.max = _this.$formatData.DateDiff(
          _this.modelPlayConfig.startDate,
          _this.modelPlayConfig.endDate
        ); 
        _this.sliderChange(_this.nowInitValue,'init');
        /*
          所有的模拟  都需要判断是plan还是actual，
          停止模拟需要恢复到初始化模拟状态
          this.timeSlidervalue = 当前时间
          mark   修改
          着色清空
        */
      }else{
        _this.setLegend = false;
        /*
          this.timeSlidervalue = 0;
          mark  修改
          着色清空
          调用sliderChange(0)
          
        */ 
        if(_this.getPlayingData == null || _this.getPlayingData.List.length == 0){
          _this.$message.error('当前任务暂无实际数据')
          _this.checkValue = 'plan';
          return
        }
        _this.listSetColor = [];
        _this.timeSlidervalue = 0;
        _this.getPlayingDataFun();
      }
      _this.checkValue = ev;

    },
    
    // 按照实际模拟的相关数据
    getPlayingDataFun(){
        let _this = this;
        let getPlayingData = _this.getPlayingData;
        let _min = getPlayingData.start;
        let _max = getPlayingData.end;
        let diffDay = _this.$formatData.DateDiff(_min,_max);
        
        _this.dateMin = _min;
        _this.dateMax = _max;
        _this.deteDiffDay = diffDay;
        _this.modelPlayConfig.max = diffDay;
        _this.marks = {
            0: _min.toString(),
            [diffDay]: _max.toString()
        }
        
        _this.sliderChange(0);
        _this.timestepToolTip(0);
    },

    // 时间分割
    getDateSplit(start, end) {
      let sDate = new Date(start);
      let sYear = sDate.getFullYear();
      let sMonth = sDate.getMonth() + 1;
      let eDate = new Date(end);
      let eYear = eDate.getFullYear();
      let eMonth = eDate.getMonth() + 1;
      let list = []
      let j = sMonth + 1;
      for(let i=sYear; i<=eYear; i++) {
        for(; j<=12; j++) {
          list.push(`${i}.${j}`)
          if(i===eYear && j===eMonth) {
            break;
          }
        }
        j = 1
      }
      return list;
    }
  },
  beforeDestroy: function() {
    if (this.playTimeHandler) {
      clearInterval(this.playTimeHandler);
    }
  }
};
</script>
<style lang="scss" scoped>
.progress-wapper {
  position: relative;
  width: 100%;
  height: 100%;
}
.progress-loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 112px;
  background: rgba(7, 17, 41, 0.9);
  z-index: 20; 

  display: flex;
  color: #fff;
  .progress-end{
    margin: 35px 16px 0 0;
    line-height: 40px;
    
    height: 40px;
    width: 104px;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    color: #999999;
  }
  .progress-end-check{
    margin: 35px 16px 0 0;
    border-radius: 4px;
    cursor: pointer;
    color: #999999;
    /deep/ .el-select{
      width: 120px;
    }
    /deep/ .el-input--suffix .el-input__inner{
      background: rgba(7, 17, 41, 0.7);
      border: 1px solid #2899ff;
      color: #2899ff;
    }
    /deep/ .el-select .el-input .el-select__caret{
      color: #2899ff;
    }
    /deep/ .el-select-dropdown__item.selected{
      color: #2899FF !important;
    }
  }
  .loading-end{
    background: url("../../assets/images/safety/endyellow.png") no-repeat;
    background-size:  100% 100%; 
    color: #fff;
    cursor: pointer;
  }
  .loading-end-not{
    cursor: pointer;
    // cursor: not-allowed;
    background: url("../../assets/images/safety/endblue.png") no-repeat;
    background-size:  100% 100%;
  }
  .progress-btn {
    margin: 35px 16px 0;
    position: relative;
    width: 40px;
    height: 40px;
    background: #ffb224;
    border-radius: 100%;
    cursor: pointer;
    .s-e-btn {
      position: absolute;
      top: 11px;
      left: 13px;
      width: 14px;
      height: 18px;
      z-index: 1;
    }
    .start {
      background: url("../../assets/images/safety/start.png") no-repeat;
      background-size: cover;
    }
    .pause {
      background: url("../../assets/images/safety/end.png") no-repeat;
      background-size: cover;
    }
  }
  /deep/ .el-slider__stop {
    border-radius: 0;
    background-color: #2899FF;
    height: 14px;
    top: -7px;
    border-radius: 3px;
  }
  /deep/ .el-slider__marks-text {
    margin-top: -30px;
    white-space: nowrap;
    color: rgba(255, 255, 255, 0.65);
  }
  /deep/ .el-slider__runway {
    background-color: rgba(46, 65, 95, 1);
  }
  /deep/ .el-slider__bar {
    background-color: rgba(40, 153, 255, 1);
  }
  .f00 {
    background: #f00;
  }
  .play-slider {
    margin: 10px 20px 0;
    .actual-text{
      line-height: 34px;
      border-radius: 6px;
      font-size: 15px;
      padding-left: 5px;
      color: #ffffffa6;
      padding: 0px 0 10px 4px;
    }
    .actual-time{
      margin: 30px 0;
    }
    .actual-time-actual{
      margin: 0px 40px;
    }
    flex: 1;
    .one-slider{
      position: relative;
      top: -38px;
      /deep/ .el-slider__runway{
        background: transparent;
      }
      /deep/ .el-slider__button-wrapper{
        left: 0%;
        opacity: 0;
      }
      /deep/ .el-slider__marks-stop{
        background: #f00;
      }
      /deep/ .el-slider__marks-text {
        margin-top: 16px;
        margin-left: 5px;
      }
      /deep/ .el-slider__button-wrapper,/deep/ .el-slider__bar{
        display: none;
      }
      /deep/ .foo, /deep/ .bar{
        white-space: pre;
        color: #ffb224;
        font-weight: bold;
      }
      /deep/ .el-slider__stop {
        border-radius: 0;
        background-color: #ffb224;
        transform: rotate(45deg);
        height: 8px;
        width: 8px;
        top: -2px;
      }
    }
    
  }
}
.model-legend{
  top: 510px !important;
}
.progress-list-tab.tab-milestone{
  width: 270px;
  ul{
    padding:10px 12px 10px 14px;
    max-height: 324px;
    overflow-y: scroll;
  }
}
.progress-list-tab{
  position: absolute;
  top: 130px;
  right: 20px;
  border-radius: 4px;
  width: 170px;
  // max-height: 350px;
  background: rgba(7, 17, 41, 0.9);
  color: #fff;
  text-align: left;
  z-index: 10;
  p{
    background: linear-gradient(90deg, rgba(40, 153, 255, 0.5), rgba(57, 68, 121, 0.3));
    line-height: 26px;
    color: #26ABFF;
    padding-left: 12px;
  }
  ul{
    padding:10px 22px 10px 24px;
    li{
      line-height: 34px;
      // cursor: pointer;
      .model-icon{
        vertical-align: middle;
        display: inline-block;
        width: 20px;
        height: 20px;
        background: url("../../assets/images/safety/check.png") no-repeat;
        background-size: cover;
        cursor: pointer;
        margin-right: 10px;
      }
      .model-legend-icon{
        vertical-align: middle;
        display: inline-block;
        width: 20px;
        height: 20px;
        border-radius: 2px;
        background: #666666;
        // cursor: pointer;
        margin-right: 10px;
      }
      .bg096dd9{
        background: #096dd9;
      }
      .bgfa8c16{
        background: #fa8c16;
      }
      .cd4380d{
        background: rgba(212, 56, 13, 1);
      }
      .cfa8c16{
        background: rgba(250,140,22, 1);
      }
      .cffe240{
        background: rgba(255, 226, 64, 1);
      }
      .c0bc286{
        background: rgba(11, 194, 134, 1);
      }
      .c096dd9{
        background: rgba(9, 109, 217, 1);
      }
      .active{
        background: url("../../assets/images/safety/checked.png") no-repeat;
        background-size: cover;
      }
    }
  }
}
.progress-content {
  position: absolute;
  top: 130px;
  left: 20px;
  border-radius: 4px;
  width: 200px;
  max-height: 350px;
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  padding: 16px;
  overflow: auto;
  text-align: left;
  z-index: 2;
  p{
    line-height: 24px;
  }
  .slider-time {
    margin: 10px 0px;
    font-size: 16px;
    color: rgba(255, 255, 255, 0.8);
  }
  
  .actual-list{
    margin-bottom: 10px;
  }
}
.progress-content.progress-actual{
  width: 290px;
  max-height: 420px;
  /deep/ .el-divider--horizontal{
    margin: 18px 0;;
  }
}
.tooltip-model{
  position: absolute;
  right: 20px;
  bottom: 20px;
  p{
    line-height: 26px;
    color: rgb(31, 34, 31);
    vertical-align: middle;
    span{
      display: inline-block;
      width: 8px;
      height: 8px;
      margin-right: 10px;
      background: #999999;
      
    }
    span.ff00{
      background: #f00;
    }
    span.f0f0{
      background: #0f0;
    }

  }
}
.progress-model{
  width: 100%;
  height: 100%;
  background: #b3c1cd;
}
.progress-wapper /deep/ .el-loading-spinner i{
  color: rgba(255,255,255,.7);
  font-size: 26px;
}
.progress-wapper /deep/ .el-loading-spinner .el-loading-text {
  color: rgba(255,255,255,.7);
  font-size: 15px;
  line-height: 37px;
}

</style>